module.exports = __webpack_public_path__ + "img/album19_01.67c602d5.jpg";